<template>
  <div class="container py-5">
    <p v-if="shopInfo" v-html="shopInfo"/>
    <div class="filter px-2 mb-3">
      <button
        class="mx-2 p-2 mb-2"
        :style="{ background: category.id === categorySelect ? surrounding.style : null, color: category.id === categorySelect ? 'white' : null }"
        v-for="category in categories"
        :key="category.id"
        @click="categorySelect = category.id"
      >
        {{ category.title }}
      </button>
    </div>
    <div class="items d-flex flex-wrap">
      <div class="item w-100 w-sm-50 w-lg-30 px-3 mb-3" v-for="item in selectedItems" :key="item.id" @click="itemSelect = item">
        <div class="item-img" :style="{ backgroundImage: item.media.data.length > 0 ? `url(${item.media.data[0].url})`: null }" />
        <div class="item-body p-3">
          <h1 class="m-0">{{ item.name }}</h1>
          <p class="my-2">{{ item.description }}</p>
          <h4 class="price" :style="{ color: surrounding.style + '!important' }">{{ priceFormat(item.price) }}</h4>
        </div>
      </div>
    </div>
    <div
      v-if="itemSelect !== null"
      class="item-info-wrapper position-fixed"
      @click="closeItem"
    >
      <div class="item-info">
        <div class="item-info-body d-flex">
          <button
            class="close ml-auto m-2 p-2 d-block d-sm-none"
            @click="itemSelect = null"
            :style="{ background: surrounding.style, color: 'white' }"
          >
            Sluiten
          </button>
        </div>
        <div class="item-img item-info-img" :style="{ backgroundImage: itemSelect.media.data.length > 0 ? `url(${itemSelect.media.data[0].url})`: null }" />
        <div class="item-info-body p-3">
          <h1 class="m-0">{{ itemSelect.name }}</h1>
          <p class="my-2">{{ itemSelect.description }}</p>
          <h4 class="price" :style="{ color: surrounding.style + '!important' }">{{ priceFormat(itemSelect.price) }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Service from '@/services/ApiService'

export default {
  name: 'ec-business-custom-webshop',
  props: {
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    },
    webshopId: Number
  },
  data () {
    return {
      shopInfo: null,
      categories: [{
        id: 0,
        title: 'Alle'
      }],
      categorySelect: 0,
      items: [],
      itemSelect: null
    }
  },
  computed: {
    selectedItems () {
      if (this.categorySelect !== 0) {
        return this.items.filter(item => item.category.id === this.categorySelect)
      }
      return this.items
    }
  },
  methods: {
    async getShopView () {
      try {
        const shop = await Service.get('webshop/v4/' + this.webshopId)
        this.shopInfo = shop.data.comment
        shop.data.categories.data.forEach(category => {
          this.categories.push(category)
        })
        this.categories.forEach(async cat => {
          if (cat.id !== 0) {
            const products = await Service.get('webshop/v4/category/' + cat.id + '/products')
            products.data.products.data.forEach(product => {
              this.items.push(product)
            })
          }
        })
      } catch (ex) {
        console.error('GETTING DATA FAILED', ex)
      }
    },
    closeItem (e) {
      if (e.target.className.includes('item-info-wrapper')) {
        this.itemSelect = null
      }
    },
    priceFormat (price) {
      const formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      })
      return formatter.format(price)
    }
  },
  created () {
    if (this.surrounding.id === 1970) {
      this.getShopView()
    }
  }
}
</script>

<style lang="scss">
  .buwebshop {
    button {
      border: none;
      line-height: 1;
      border-radius: 6px;
      outline: none;
      background: #e6e6e6;
    }
    .item {
      cursor: pointer;
      &-img {
        height: 162px;
        width: 100%;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #efefef;
      }
      &-body {
        background: #e6e6e6;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-height: 16px;
          max-height: 32px;
        }
        .price {
          font-size: 1.2em;
        }
      }
      &-info {
        width: 820px;
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        &-img {
          height: 520px;
          @media screen and (max-width: 765px) {
            height: 350px;
          }
        }
        &-wrapper {
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          overflow-y: auto;
        }
        &-body {
          background: #e6e6e6;
          .price {
            font-size: 1.2em;
          }
        }
      }
    }
  }
</style>
